<template>
  <svg viewBox="0 0 24 24" fill="none" :stroke="stroke" stroke-width="2">
    <polyline points="20 6 9 17 4 12"></polyline>
  </svg>
</template>

<script setup>
defineProps({
  stroke: {
    type: String,
    default: 'currentColor'
  }
})
</script>
